import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Alert, AlertIcon, Box, Button, Heading, Text, Tooltip } from '@chakra-ui/react';
import { Mutation } from '../../../generated/graphql';
import { REVOKE_EMAIL_LOGIN_LINKS } from '../queries';

export function EmailLinkSecurity() {
  const [count, setCount] = useState<number>();
  const [revoke, { loading, error }] = useMutation<Pick<Mutation, 'revokeEmailLoginLinks'>>(REVOKE_EMAIL_LOGIN_LINKS);
  return <Box borderWidth="1px" borderRadius="md" p={5}>
    <Heading size="sm" mb={2}>Email sign-in links</Heading>
    <Text mb={4}>Stop your previous email links from signing you in. Existing sessions stay signed in; request a new email link next time.</Text>
    <Tooltip label="Immediately revoke your email sign-in links. This does not sign out your current session.">
      <Button isLoading={loading} onClick={async () => { try { const result = await revoke(); if (result.data) setCount(result.data.revokeEmailLoginLinks); } catch { /* visible error below */ } }}>Revoke my email links</Button>
    </Tooltip>
    {count !== undefined && <Text role="status" mt={3}>{count} email sign-in {count === 1 ? 'link revoked' : 'links revoked'}.</Text>}
    {error && <Alert status="error" mt={3}><AlertIcon />{error.message}</Alert>}
  </Box>;
}
